import * as AircraftPopup from './components/AircraftPopup.css';
import * as FlightClass from './components/FlightClass/FlightClass.css';
import * as AircraftPopupCarousel from './components/Carousel/AircraftPopupCarousel.css';
export default {
    AircraftPopup: AircraftPopup,
    FlightClass: FlightClass,
    AircraftPopupCarousel: AircraftPopupCarousel
};
